module.exports = "<div class=\"panel panel-default panel-tabs\" *ngIf=\"paiement\">\n    <div *ngIf=\"hideActions\" class=\"panel-heading\">\n        Paiement\n    </div>\n   \t<div class=\"panel-body\">\n\n     </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /builds/eveasoft/lea/lea-front/src/app/shared/paiement/edit/edit.component.html
// module id = ../../../../../src/app/shared/paiement/edit/edit.component.html
// module chunks = main